<template>
  <div class="ReportDetailPagePurchase" style="padding: 20px;width: 500px;background-color: #fafafa" >
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/BlockedInfoView' }" >冻结名单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="24">
        <div style="font-size: 25px;margin-top: 15px;">
          <p>冻结名单管理</p>
        </div>
      </el-col>
    </el-row>
    <div style="width: 100%; font-family: 宋体; font-size: 25px;font-weight: bold">
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" style=" margin-top: 30px" >
        <el-form-item label="供应商" prop="selectedSupplierIds">
          <el-select  v-model="ruleForm2.selectedSupplierIds" value-key="id" filterable multiple placeholder="请选择"  @change="supplierid()" style="width: 400px">
            <el-option
              v-for="(item) in user"
              :key="item.id"
              :label="item.name"
              :value='item'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="selectRegionals">
          <el-select popper-class="el-select" v-model.number="ruleForm2.selectedRegionals" multiple style="width: 400px" value-key="id" @change="selectRegionalss" placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm2.selectedSupplierIds != '' && ruleForm2.selectedSupplierIds.length === 1 ?false:true">
            <select-all-option v-model="ruleForm2.selectedRegionals" group-value="regionals" @change="selectRegionalss" :data="selectRegionals"/>
            <el-option-group
              v-for="group in selectRegionals"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.regionals"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="省份" prop="selectProvinces">
          <el-select popper-class="el-select" v-model.number="ruleForm2.selectedProvinces"  style="width: 400px" value-key="id"   multiple placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm2.selectedRegionals != '' ?false:true">
            <select-all-option v-model="ruleForm2.selectedProvinces" group-value="children" :data="selectProvinces"/>
            <el-option-group
              v-for="group in selectProvinces"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.children"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <el-row style="margin-left: 100px;text-align: center">
        <el-col :span="12">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading" @click="importBlockedInfo">导出填写模板</el-button>
        </el-col>
        <el-col :span="12">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading2" @click="uploadLabel">上传冻结数据</el-button>
          <input type="file" ref="uploadLabel" v-show="false" accept=".xls,.xlsx" @change="putBlockedInfoExcel"/>
        </el-col>
      </el-row>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="1000px" top="10%" :show-close="false">
      <img width="100%" :src="freeze">
    </el-dialog>
  </div>

</template>

<script>
import { allUser } from '@/api/ReportDetailPage'
import {importBlockedInfo,putBlockedInfoExcel,importBlockedInfoAllNetWork} from '@/api/BlockedInfo'
import selectAllOption from "@/components/selectAllOption";
import images1 from "@/assets/freezeLevel.png";

export default {
  components: {selectAllOption},
  data () {
    return {
      visible: false,
      dialogVisible: false,
      ruleForm2: { selectedSupplierIds: '', selectedRegionals: '', selectedProvinces: ''
      },
      // 判断供应商是否选择
      rules2: {
        selectedSupplierIds: [
          { required: true, message: '请至少选择一个供应商', trigger: 'change' }
        ]
      },
      user: [],
      value: '',
      selectRegionals: [],
      selectProvinces: [],
      token: '',
      loading: false,
      loading2: false,
      fileList:[],
      successMsg: [],
      supplierId: '',
      freeze: images1,
    }
  },
  created () {
    // 进入测页面以后 查询出下拉框的所有值
    this.allUser();
    this.$store.commit('addTips',['新增冻结导购：添加一行，填写手机号并设置冻结等级，点此查看冻结等级对应权限表；',
      '修改或解除冻结：将表格中的冻结等级修改为解除，或设为其他等级；',
      '若导购的冻结等级设为风险冻结时：该导购将在 "全网通报虚假申报导购名单"（点击下载），请谨慎设置。'
    ]);

    setTimeout(function(){
      var element = document.getElementsByClassName('el-header')[2]
      element.getElementsByTagName('div')[2].innerHTML = '<div><div><span style="font-weight: 600">新增冻结导购：</span>添加一行，填写手机号并设置冻结等级，<a id="a1" style="cursor: pointer;color: #0563C1">点此查看冻结等级对应权限表</a>；</div><br></div>';
      element.getElementsByTagName('div')[5].innerHTML = '<div><div><span style="font-weight: 600">修改或解除冻结：</span>将表格中的冻结等级修改为解除，或设为其他等级；</div><br></div>';
      element.getElementsByTagName('div')[8].innerHTML = '<div><div>若导购的冻结等级设为<span style="font-weight: 600">风险冻结</span>时：该导购将在 <a id="a2" style="cursor: pointer;color:#0563C1" onclick="updateSocket1()">"全网通报虚假申报导购名单"（点击下载）</a>，请谨慎设置。</div><br></div>';
      document.getElementById("a1").onclick = function (){
        updateSocket2(true)
      }
    },0);
  },
  mounted() {
    window.updateSocket1 = this.importBlockedInfoAllNetWork;
    window.updateSocket2 = this.freeze1;
  },
  methods: {
    freeze1(data){
      this.dialogVisible = data;
    },
    uploadLabel(){
      if (this.ruleForm2.selectedSupplierIds.length <1){
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
        return
      }
      this.supplierId = this.ruleForm2.selectedSupplierIds[0].id
      this.$refs.uploadLabel.click()
    },
    putBlockedInfoExcel(){
      this.loading2 = true
      let inputDOM = this.$refs.uploadLabel
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file",file)
      putBlockedInfoExcel(this.token,this.supplierId,formData).then(r => {
        let {data} = r
        if (data.code == 200){
          this.$notify.success({
            title: '成功',
            message: data.msg,
            position: 'bottom-right'
          })
        }
        if (data.code == 1)
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '数据中心修改失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading2 = false
        this.$refs.uploadLabel.value = ''
      })
    },
    supplierid () {
      // 根据选择的供应商赋值给品牌和区域
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        if (this.ruleForm2.selectedSupplierIds.length > 1) {
          this.ruleForm2.selectedSupplierIds.splice(1, 1)
          this.$notify({
            title: '警告',
            message: '只能选择一个供应商',
            type: 'warning',
            position: 'bottom-right'
          })
        }
        this.selectRegionals = this.ruleForm2.selectedSupplierIds
      } else {
        this.ruleForm2.selectedRegionals = []
        this.ruleForm2.selectedProvinces = []
      }
    },
    selectRegionalss () {
      // 根据选择的区域赋值给不同的省份
      this.selectProvinces = this.ruleForm2.selectedRegionals
    },
    allUser () {
      this.token = localStorage.getItem('token')
      allUser(this.token,localStorage.getItem('dashboardSales') == 1 ? null : localStorage.getItem('userSupplierId')).then(res => {
        if (res.data.suppliers != null) {
          this.user = res.data.suppliers
          if (this.user.length == 1){
            this.ruleForm2.selectedSupplierIds = this.user
            this.supplierid();
          }
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    importBlockedInfo () {
      if (this.ruleForm2.selectedSupplierIds != '') {
        this.token = localStorage.getItem('token')
        if (this.ruleForm2.selectedBrands == '') {
          this.ruleForm2.selectedBrands = this.ruleForm2.selectedParentBrands
        }
        this.loading = true
        console.log(this.ruleForm2)
        importBlockedInfo(this.token, this.ruleForm2).then(res => {
          if (res !== null) {
            this.$notify({
              type: 'success',
              message: '导出成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.handleDownload(res)
            this.loading = false
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500){
            this.$notify({
              title: '错误',
              message: '导出错误，请及时联系管理员',
              type: 'error',
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    importBlockedInfoAllNetWork () {
      importBlockedInfoAllNetWork(this.token).then(res => {
        if (res !== null) {
          this.$notify({
            type: 'success',
            message: '导出成功',
            title: '成功',
            position: 'bottom-right'
          })
          this.handleDownload(res)
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify({
            title: '错误',
            message: '导出错误，请及时联系管理员',
            type: 'error',
            position: 'bottom-right'
          })
        }
      })
    },
    handleDownload (res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style scoped>
.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

>>> .el-dialog__header {
  padding: 0px;
}

>>> .el-dialog__body {
  padding: 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>
